
@if (availableInstrument) {
  <div data-cy="available-instrument">
    <div class="toggler-container">
      <div
        class="togglable "
        [ngClass]="{ 'togglable--three-row': hideAddButtons }"
        (click)="toggle()"
        (keydown.space)="toggle()"
        (keydown.enter)="toggle()"
        tabindex="0"
        >
        <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': toggled ? 'rotate(180deg)' : '' }"></svg-icon>
        <div class="name" data-cy="available-instrument-name">
          {{ availableInstrument.humanName }}
        </div>
      </div>
      <div class="performance-container">
        <div class="chart-container">
          <canvas
            baseChart
            #myChart="base-chart"
            [data]="yieldChartData"
            [options]="hiddenAxisChartOptions"
            [type]="'line'"
            [legend]="false"
            >
          </canvas>
        </div>
        <div class="performance-percentage" [ngClass]="{ 'performance-percentage--negative': negativeYield }">
          @if (selectedPerformance === 1) {
            {{ availableInstrument.yield1Y * 100 | number:'1.1-1' }} %
          }
          @if (selectedPerformance === 3) {
            {{ availableInstrument.yield3Y * 100 | number:'1.1-1' }} %
          }
          @if (selectedPerformance === 5) {
            {{ availableInstrument.yield5Y * 100 | number:'1.1-1' }} %
          }
        </div>
      </div>
      <div
        class="risk-score-container"
        data-cy="risk-score-container"
        [ngClass]="{ 'risk-score-container--no-margin': hideAddButtons }"
        >
        @for (score of defaultInstrumentRiskLevels; track score) {
          <div
            class="risk-dot"
            data-cy="risk-dot"
        [ngClass]="{
          'risk-dot--active': availableInstrument.riskScore === score
        }"
          ></div>
        }
      </div>
      @if (!hideAddButtons) {
        <div class="action-button">
          @if (!instrumentAlreadyAdded) {
            <div
              class="instrument-btn instrument-btn--add-button"
              (click)="addInstrument()"
              data-cy="add-instrument-to-strategy-btn"
              (keydown.space)="addInstrument()"
              (keydown.enter)="addInstrument()"
              tabindex="0"
            >
              <svg-icon src="assets/icons/plus.svg" [svgStyle]="{ 'width.px':15 }"></svg-icon>
            </div>
          } @else {
            <div
              class="instrument-btn instrument-btn--remove-button"
              (click)="removeInstrument()"
              (keydown.space)="removeInstrument()"
              (keydown.enter)="removeInstrument()"
              tabindex="0"
            >
              <svg-icon src="assets/icons/check.svg" [svgStyle]="{ 'width.px':15 }"></svg-icon>
            </div>
          }
        </div>
      }
    </div>
    @if (toggled) {
      <div class="description">
        @if (availableInstrument.name) {
          <div class="pb-2">
            {{ availableInstrument.name }}
          </div>
        }
        <span [innerHTML]="availableInstrument.description | htmlFormat"></span>
        @if (availableInstrument.web) {
          <a
            class="description-web"
            href="{{ availableInstrument.web }}"
            target="_blank"
            >
            {{ 'dropdown.productsWeb' | translate }}
          </a>
        }
      </div>
    }
    <hr class="desktop-divider">
  </div>
}
